import {
  IMPORT_FILTER_DATA,
  UPDATE_QUOTES,
  UNSET_QUOTE,
} from "../constants/actionTypes";

const initialState = { bomlines: [], quotes: [], excelData: [] };
const importTable = (state = initialState, action) => {
  switch (action.type) {
    case IMPORT_FILTER_DATA:
      return {
        ...action.data,
        // Prefer explicit excelData (original import order) for quote index mapping
        excelData: action.data.excelData || action.data.bomlines,
        invalidQuantityColumns: action.data.invalidQuantityColumns,
        issue_report: action.data.issue_report || null,
      };
    case UPDATE_QUOTES:
      let updateQuote = {
        ...state,
        bomlines: action.data.bomlines,
        quotes: action.data.quotes,
      };
      if (action.data.excelData) {
        updateQuote.excelData = action.data.excelData;
      }
      if (action.data.issue_report) {
        updateQuote.issue_report = action.data.issue_report;
      }
      return updateQuote;
    case UNSET_QUOTE:
      return initialState;
    default:
      return state;
  }
};

export default importTable;
